export const headerStyle = {
  backgroundColor: "#f4f6f9",
  borderRadius: "6px",
  paddingLeft: "12px",
  width: "100%",
  paddingTop: "8px",
  paddingBottom: "8px",
};

export const checkBoxStyle = {
  color: "#4663ff",
  marginLeft: "12px",
  borderRadius: "6px",
  "&.Mui-checked": {
    color: "#4663ff",
  },
  "& .MuiSvgIcon-root": { fontSize: 15 },
};

export const titleStyle = {
  color: "#6f7d95 !important",
  fontWeight: "700 !important",
  fontSize: "1rem !important",
};

export const labelStyle = {
  color: "#6f7d95 !important",
  fontWeight: "500 !important",
  fontSize: "0.9rem !important",
};
